import { Link } from "react-router-dom";
import { ShieldAlert, ArrowRight } from "lucide-react";
import { isVerified } from "@/lib/account";
import EmailVerifyNotice from "./EmailVerifyNotice";

const KYC_TEXT = {
  not_submitted: "Verify your identity to unlock deposits, investing and withdrawals.",
  pending: "Your identity documents are under review. We'll email you when it's done.",
  rejected: "Your identity verification needs attention. Please update your documents.",
};

export default function AccountStatusBanner({ user }) {
  if (isVerified(user)) return null;
  return (
    <div className="space-y-3" data-testid="account-status-banner">
      {!user.email_verified && <EmailVerifyNotice />}
      {user.kyc_status !== "approved" && (
        <div className="flex flex-wrap items-center gap-4 rounded-2xl border border-blue-500/30 bg-blue-500/10 p-5">
          <ShieldAlert className="h-5 w-5 text-blue-400" />
          <p className="flex-1 text-sm text-blue-200" data-testid="kyc-banner-text">{KYC_TEXT[user.kyc_status] || KYC_TEXT.not_submitted}</p>
          <Link to="/verification" className="btn-ghost !px-4 !py-2 text-xs" data-testid="kyc-banner-link">
            {user.kyc_status === "pending" ? "View status" : "Verify identity"} <ArrowRight className="h-3.5 w-3.5" />
          </Link>
        </div>
      )}
    </div>
  );
}
